
export const APP_VERSION = {
  version: '1.1.0',
  build: '20261028.1',
  buildId: '0'
};
